export default "__VITE_ASSET__msW9LMLT__"